import React from 'react';
import { Tag } from 'antd';

const DashboardContent = ({applicationsData}) => {
  const isObjectEmpty = (data) => {
    for (const item of data) {
        for (const key in item) {
            if (typeof item[key] === 'object') {
                const subItem = item[key];
                for (const subKey in subItem) {
                    if (subItem[subKey] !== '') {
                        return false;
                    }
                }
            } else if (item[key] !== '') {
                return false;
            }
        }
    }
    return true;
  };
  const tagColor = (status) => {
    switch(status) {
      case 'Рассматривается':
        return 'blue';
      case 'Согласовано':
        return 'green';
      case 'Отклонено':
        return 'red';
    }
  }
  return <>    
    <table className='applicationsTable'>
      <tbody>
        <tr>
          <th><p>Номер документа</p></th>
          <th><p>Дата документа</p></th>
          <th><p>Состояние</p></th>
          <th><p>Ответственный</p></th>
          <th><p>Комментарий</p></th>
        </tr>
        {!isObjectEmpty(applicationsData) && applicationsData.map((app, index) => (
        <tr key={ "app" + index.toString()} onClick={()=>console.log('click')}>
          <td><p>{app.DocNumber}</p></td>
          <td><p>{app.Date.replace('T', ' ')}</p></td>
          <td><p><Tag color={tagColor(app.DocStatus)}>{app.DocStatus}</Tag></p></td>
          <td><p>{app.AssignedTo}</p></td>
          <td><p>{app.Comment}</p></td>
        </tr>
        ))}
      </tbody>
    </table>
  </>;
};

export default DashboardContent;